export const FIVE_SECONDS = 5000
export const REFETCH_RUN_LIMIT = 36
